<template>
  <div class="row">
    <div class="col">
      <div class="is-center">
        <picture>
          <source srcset="../assets/failx400.webp" type="image/webp">
          <source srcset="../assets/failx400.jpg" type="image/jpeg">
          <img src="../assets/failx400.jpg" alt="FAIL defined">
        </picture>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroImage'
}
</script>

<style>

</style>
